var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`mb-1 flex items-center justify-center w-fit heading-6 whitespace-nowrap border border-gray2 rounded text-${_vm.textsColor} px-2 py-1  mr-1`},[(_vm.iconClass !== '')?_c('span',{},[_c('i',{staticClass:"mr-1",class:`${_vm.iconClass}`})]):_vm._e(),_vm._v(" "+_vm._s(_vm.chipText))])
}
var staticRenderFns = []

export { render, staticRenderFns }